'use es6';

import PropTypes from 'prop-types';
import { OLAF, OZ } from 'HubStyleTokens/colors';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import Small from 'UIComponents/elements/Small';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { getInstallsBucket } from '../../utils/offerings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AppCardInstalls = ({
  installsCount,
  installed,
  showIsNewApp
}) => {
  if (installed) {
    return /*#__PURE__*/_jsxs("span", {
      className: "align-baseline",
      children: [/*#__PURE__*/_jsx(UIIconCircle, {
        className: "m-right-2",
        color: OLAF,
        backgroundColor: OZ,
        name: "success",
        padding: 0.2,
        size: 9
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystemMarketplaceCore.cards.appCard.installs.installed"
        })
      })]
    });
  }
  const installsBucket = getInstallsBucket(installsCount);
  let renderedMessage;
  if (showIsNewApp) {
    renderedMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ecosystemMarketplaceCore.cards.appCard.installs.new"
    });
  } else if (installsBucket) {
    renderedMessage = /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "ecosystemMarketplaceCore.cards.appCard.installs.bucket_jsx",
      options: {
        value: installsBucket
      },
      elements: {
        Number: FormattedNumber
      }
    });
  } else {
    renderedMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ecosystemMarketplaceCore.cards.appCard.installs.min"
    });
  }
  return /*#__PURE__*/_jsx(Small, {
    use: "help",
    children: renderedMessage
  });
};
AppCardInstalls.propTypes = {
  installed: PropTypes.bool,
  installsCount: PropTypes.number.isRequired,
  showIsNewApp: PropTypes.bool
};
export default AppCardInstalls;